import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ButtonComp } from 'atoms/Buttons';
import ImageComponent from 'atoms/Image';
import { UserOrderContext } from 'context/context';
import SELECT_CONTENT_DISPOSITION from '../Data/SampleData';
import {
  getValueOrDefaultObject,
  isEmptyEvery,
  isEmptyObject,
  getDispositionFomatForSelectContent,
} from 'common/utilities/utils';
import SELECT_CONTENT_DISPOSITION_CONSTANTS from '../Constants/selectContentDispositionConstants';
import { availableTimeSlot } from '../SelectContentDispositionUtilities/SelectContentDispositionUtil';
import { displayNotifyMessage } from 'organisms/SearchStore/SearchStoreUtilities/AutoDetectionUtils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
/**
 *
 * @param {*} props - props for the start order item
 *
 */
const SelectContentDispositionItems = props => {
  const {
    contentData = {},
    clickHandler = null,
    dispositionChange,
    activeDisposition,
    selectedInfo = {},
    showBlackStripeContent = true,
    headerTrackOrder,
  } = props;
  const { GoogleMapLocationImage, Clock } = IMAGE_PATH;
  const {
    headline: contentText = '',
    subHeadline: infoText = null,
    supportedDispositionsData: orderTypes = [],
    src = '',
    alt,
    ariaLabel = '',
  } = contentData;
  let tenantReducer = useSelector(data => data.tenantReducer);
  const location = useLocation();
  const { storeSection } = SELECT_CONTENT_DISPOSITION.contentData;
  const { userOrderState } = useContext(UserOrderContext);
  const { ORDER_TYPE_STORE_INFO_FROM, ORDER_TYPE_STORE_INFO_TO, ORDER_TYPE_STORE_INFO_AT, HOMEPATHSELECT, HOMEPATH } =
    SELECT_CONTENT_DISPOSITION_CONSTANTS;
  const { buttonText } = storeSection;
  const dispositionNew = isEmptyEvery(selectedInfo.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : selectedInfo.dispositionNew;
  const dispositionType = dispositionNew ? dispositionNew.type : '';
  const selectedStore = dispositionNew ? dispositionNew.store : {};
  const date = dispositionNew ? dispositionNew.date : '';
  const time = dispositionNew ? dispositionNew.time : '';
  const interval = dispositionNew ? dispositionNew.interval : 0;
  const storeInfo = getValueOrDefaultObject(dispositionNew?.store);
  const selectedDateTime = { date, time, interval };
  const [showSelectOrderButtons, setShowSelectOrderButtons] = useState(false);
  const To_or_From =
    dispositionType === 'Delivery'
      ? ORDER_TYPE_STORE_INFO_TO
      : (dispositionType === 'Pickup' && ORDER_TYPE_STORE_INFO_FROM) || ORDER_TYPE_STORE_INFO_AT;
  useEffect(() => {
    location?.pathname === HOMEPATH || location?.pathname === HOMEPATHSELECT
      ? setShowSelectOrderButtons(true)
      : setShowSelectOrderButtons(false);
  }, [location, HOMEPATH, HOMEPATHSELECT]);

  return (
    <React.Fragment>
      {isEmptyObject(selectedStore) && showBlackStripeContent && (
        <div className='headerBottom content-ribbon' data-testid='select-start-order-items'>
          <div className='headBottomParent content-parent'>
            <div className='headBottomTxt content-text'>
              <div className='store-location'>
                <div>
                  <ImageComponent
                    srcFile={GoogleMapLocationImage}
                    alt={alt || 'location-icon'}
                    className='content-location-img'
                  />
                </div>
                <div className='content-stroe-wrap'>
                  <span className='content-store address'>
                    {getDispositionFomatForSelectContent(dispositionType)} {To_or_From}:{' '}
                    {dispositionType.toLowerCase() === 'delivery'
                      ? dispositionNew?.deliveryAddress
                      : selectedStore?.summary?.name}
                  </span>
                </div>
              </div>
              <div className='content-time'>
                <span>
                  <ImageComponent srcFile={Clock} alt={alt || 'location-icon'} className='content-clock-img' />
                </span>

                <span className='content-store'>
                  {' '}
                  {selectedDateTime && availableTimeSlot(selectedDateTime, storeInfo, tenantReducer)}
                </span>
              </div>
            </div>
            <ButtonComp
              className='button transparent-btn white-border change-store-btn'
              aria-label={ariaLabel || buttonText}
              onClickHandler={e => clickHandler(e, selectedStore)}
              id='changeOrderItemButton'
              type='submit'
            >
              <span>{buttonText}</span>
            </ButtonComp>
          </div>
        </div>
      )}
      {headerTrackOrder && headerTrackOrder()}
      {userOrderState.showLocationBlockBanner && displayNotifyMessage()}
      {showSelectOrderButtons ? (
        <div className='select-content-disposition'>
          <div className='stripes'>
            <ImageComponent srcFile={src} alt={alt || ''} />
          </div>
          <div className='disposition-headline'>{contentText}</div>
          <div role='alert' className='disposition-info-text'>
            <span>{infoText}</span>
          </div>
          <div className='disposition-btns mb-2'>
            {orderTypes.map(item => {
              return (
                <ButtonComp
                  className={
                    activeDisposition === item?.dispositionType?.toUpperCase()
                      ? 'button grayButton active-disposition'
                      : 'button grayButton'
                  }
                  data-testid='disposition-change-btn'
                  key={item.buttonText}
                  onClickHandler={event => {
                    dispositionChange(event, item?.dispositionType?.toUpperCase());
                  }}
                  aria-label={item.buttonText}
                >
                  {item.buttonText}
                </ButtonComp>
              );
            })}
          </div>
        </div>
      ) : null}
    </React.Fragment>
  );
};
export default SelectContentDispositionItems;
